import { useQuery } from '@tanstack/react-query';
import useStorage from '@/shared/hooks/use-storage';

export interface AuthProfileState {
  profilePhoto: string | null;
  displayName: string | null;
  email: string;
}

/**
 * Hook to get user profile data from auth storage via React Query
 * This ensures reactivity when the storage is updated
 */
export const useAuthProfile = () => {
  const { store } = useStorage();

  return useQuery({
    queryKey: ['auth-profile'],
    queryFn: async (): Promise<AuthProfileState | null> => {
      const auth = await store.getAuth();
      if (!auth) {
        return null;
      }

      return {
        profilePhoto: auth.user.userProfile?.profilePhoto || null,
        email: auth.user.email || '',
        displayName: auth.user.userProfile?.displayName || auth.user.email || null,
      };
    },
    staleTime: Infinity,
    retry: false,
  });
};
